import { PXRESEVERPROP, ARRAYPXRESEVERPROP } from "utils/index"
import { isInvalidNumber, defaultNumber } from "./buildModel"

/**
 * @param {Object} model pc需要rem转px的数据
 */
export function reverseBuildModel(model, baseWidth = 192) {
  baseRevereBuildModel(model, baseWidth)
}
/**
 * @param {Object} model app需要rem转px的数据
 */
export function reverseBuildModelForApp(model, baseWidth = 16 * (41.4 / 16)) {
  baseRevereBuildModel(model, baseWidth)
}

function baseRevereBuildModel(model, baseWidth) {
  for (let i in model) {
    if (model[i] != null) {
      try {
        if (typeof model[i] == "object") {
          if (i === "chartOption") {
            reverseChartFormatter(model[i])
          } else if (ARRAYPXRESEVERPROP.indexOf(i) !== -1) {
            //数组且需要转回来
            if (Array.isArray(model[i])) {
              model[i] = model[i].map(item =>
                //isNaN判断是为了兼容部分NaN数据
                item === null ? 1 : String(item).includes("||") ? Number(item.split("||")[0]) : item
              )
            }
          } else if (i === "event") {
            reverseFixEvents(model[i], baseWidth)
            continue
          } else {
            baseRevereBuildModel(model[i], baseWidth)
          }
        } else {
          if (i === "swiperMode" && model[i]) {
            model[i] = false
          }
          let needFix = handdleLengthUnitFix(model[i])
          //兼容部分为NaN的数据 与主逻辑无关
          if (PXRESEVERPROP.indexOf(i) !== -1 && isInvalidNumber(model[i])) {
            model[i] = defaultNumber(i)
          } else if (PXRESEVERPROP.indexOf(i) !== -1 && needFix) {
            model[i] = model[i].includes("||")
              ? Number(model[i].split("||")[0])
              : handdleNumberPointFix(Number(String(model[i]).slice(0, -3)) * baseWidth)
          }
        }
      } catch (e) {
        console.log("转换px报错", e)
      }
    }
  }
}
function reverseFixEvents(model, baseWidth) {
  //全部事件对象
  Object.keys(model).forEach(eventId => {
    // 具体事件对象
    const itemEvents = model[eventId].events
    Object.keys(itemEvents).forEach(eventType => {
      // 具体大事件分类对象
      const eventSubs = itemEvents[eventType]
      Object.keys(eventSubs).forEach(eventName => {
        //具体小事件的数组
        const events = eventSubs[eventName]
        events.forEach(event => {
          const { eventMovement, movementType, update } = event
          if (eventMovement === "component" && movementType === "options") {
            const { type, option } = update
            if (type === "diff") {
              option.forEach(itemOpt => {
                let { path, value } = itemOpt
                path = path.includes(".") ? path.split(".")[0] : path
                let needFix = handdleLengthUnitFix(value)
                if (PXRESEVERPROP.indexOf(path) !== -1 && isInvalidNumber(value)) {
                  itemOpt.value = defaultNumber(path)
                } else if (PXRESEVERPROP.indexOf(path) !== -1 && needFix) {
                  itemOpt.value = value.includes("||")
                    ? Number(value.split("||")[0])
                    : handdleNumberPointFix(Number(String(value).slice(0, -3)) * baseWidth)
                }
              })
            } else {
              baseRevereBuildModel(option, baseWidth)
            }
          }
        })
      })
    })
  })
}
/**
 * @param {Object} model 大屏需要把px数据转为数字
 */
export function reverseBuildModelForBigScreen(model) {
  for (let i in model) {
    if (model[i] != null) {
      if (typeof model[i] == "object") {
        if (i === "chartOption") {
          reverseChartFormatter(model[i])
          return
        } else {
          reverseBuildModelForBigScreen(model[i])
        }
      } else {
        if (i === "swiperMode" && model[i]) model[i] = false
        let needFix = handdleLengthUnitFixBigScreen(model[i])
        if (PXRESEVERPROP.indexOf(i) > -1 && typeof model[i] !== "object") {
          model[i] = needFix ? parseFloat(model[i].slice(0, -2)) : model[i]
        }
      }
    }
  }
}
function reverseChartFormatter(model) {
  for (let k in model) {
    if (typeof model[k] === "object" && model[k] !== null && Object.keys(model[k]).length && k !== "formatter") {
      reverseChartFormatter(model[k])
    } else {
      if (k === "formatter" && model.tempFormatter) {
        model[k] = model.tempFormatter.join("")
        model[k] = model[k].replaceAll("&lt;", "<")
        model[k] = model[k].replaceAll("&gt;", ">")
      }
    }
  }
}

function handdleNumberPointFix(num) {
  let _num = num
  let len = String(_num).indexOf(".") !== -1 ? String(_num).split(".")[1].length : null
  return len > 6 && len !== null ? _num.toFixed(6) : _num
}
function handdleLengthUnitFix(model) {
  if (typeof model === "string" && model.includes("rem")) {
    return true
  }
  return false
}
function handdleLengthUnitFixBigScreen(model) {
  let lengthUnit = null
  if (typeof model === "string") {
    lengthUnit = model.slice(-2)
  }
  if (lengthUnit === "px") {
    return true
  }
  return false
}
